module.exports = __webpack_public_path__ + "static/media/35.9f63dc47.jpeg";